// Language Popup Configuration
// Set to true to show popup every time page loads (for testing)
// Set to false to show popup only once per user (production behavior)
export const SHOW_POPUP_EVERY_TIME = true;

// Popup delay in milliseconds (1000 = 1 second, 2500 = 2.5 seconds)
export const POPUP_DELAY_MS = 6000;

// Alternative: You can also control this via environment variable
// export const SHOW_POPUP_EVERY_TIME = process.env.NODE_ENV === 'development';
